import {
  Badge,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  EllipsisVerticalIcon,
  Table,
  TableCell,
  TableRow,
} from '@fukuri-admins/ui/common';
import { iconButtonVariants } from '@fukuri-admins/ui/common/IconButton/logic';
import styles from './styles.module.scss';

/**
 * 社内報一覧の各アイテムの UI 型
 */
type InternalNewsListItem = {
  id: number;
  title: string;
  /** 表示用フォーマット済み日時（例: "2026年2月4日 10:00"） */
  publishAt: string;
  status: 'published' | 'scheduled';
  /** "公開済み" | "予約投稿" */
  statusLabel: string;
  badgeStatus: 'success' | 'info';
  /** 閲覧率（例: "90%"） */
  viewRate: string;
};

type Props = {
  items: InternalNewsListItem[];
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
  onDetailClick: (id: number) => void;
};

/**
 * 社内報一覧テーブルコンポーネント
 */
export const InternalNewsTable: React.FC<Props> = ({ items, onEdit, onDelete, onDetailClick }) => (
  <Table
    isFixed
    headers={[
      { label: 'ステータス', className: styles.statusCol },
      { label: 'タイトル' },
      { label: '公開日時', className: styles.publishedAtCol },
      { label: '閲覧率', className: styles.viewRateCol },
      { label: '設定', className: styles.actionCol },
    ]}
  >
    {items.map(item => (
      <TableRow key={item.id} onClick={() => onDetailClick(item.id)}>
        <TableCell>
          <Badge status={item.badgeStatus} variant='subtle' size='sm' label={item.statusLabel} />
        </TableCell>
        <TableCell className={styles.titleCell}>{item.title}</TableCell>
        <TableCell>{item.publishAt}</TableCell>
        <TableCell>{item.viewRate}</TableCell>
        <TableCell align='center'>
          <DropdownMenu>
            <DropdownMenuTrigger>
              <button
                type='button'
                className={iconButtonVariants({ variant: 'ghost', size: 'sm' })}
                aria-label='設定メニューを開く'
                onClick={e => e.stopPropagation()}
              >
                <EllipsisVerticalIcon />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align='end' onClick={e => e.stopPropagation()}>
              <DropdownMenuItem onSelect={() => onEdit(item.id)}>編集</DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem className={styles.deleteItem} onSelect={() => onDelete(item.id)}>
                削除
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </TableCell>
      </TableRow>
    ))}
  </Table>
);
